import { DYNAMIC_FORM_GET, DYNAMIC_FORM_SENT_SUCCESS } from '../constants.js';

const defaultState = {
    formData: {},
    formSentText: '',
    formSentSuccess: false,
    errors: {},
}

export const dynamicForms = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case DYNAMIC_FORM_GET:
        case DYNAMIC_FORM_SENT_SUCCESS:
            return {
                ...state,
                ...payload,
            };
        default:
            return state;   
    }
} 